export default class JobField{
    id;
    name;
    createdAt;
    constructor(data){
        this.id=data?.id;
        this.name=data?.name;
        this.createdAt=data?.created_at;
    }
}